import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/Login",
      component: resolve => require(["@/page/Login.vue"], resolve)
    },
    {
      path: "/",
      component: resolve => require(["@/page/index.vue"], resolve),
      redirect: "/article/article_list",
      children: [
        {
          path: "/case/add_case",
          name: "/case/case_list",
          component: resolve => require(["@/page/case/add_case.vue"], resolve)
        },
        {
          path: "/case/case_list",
          name: "/case/case_list",
          component: resolve => require(["@/page/case/case_list.vue"], resolve)
        },
        {
          path: "/member/add_member",
          name: "/member/member_list",
          component: resolve =>
            require(["@/page/member/add_member.vue"], resolve)
        },
        {
          path: "/member/member_list",
          name: "/member/member_list",
          component: resolve =>
            require(["@/page/member/member_list.vue"], resolve)
        },
        {
          path: "/address/address",
          name: "/address/address",
          component: resolve => require(["@/page/address/address.vue"], resolve)
        },
        {
          path: "/address/add_address",
          name: "/address/address",
          component: resolve =>
            require(["@/page/address/add_address.vue"], resolve)
        },
        {
          path: "/article/article_list",
          name: "/article/article_list",
          component: resolve =>
            require(["@/page/article/article_list.vue"], resolve)
        },
        {
          path: "/article/add_article",
          name: "/article/article_list",
          component: resolve =>
            require(["@/page/article/add_article.vue"], resolve)
        },
        {
          path: "/article/news_list",
          name: "/article/news_list",
          component: resolve =>
            require(["@/page/article/news_list.vue"], resolve)
        },
        {
          path: "/article/add_news",
          name: "/article/add_news",
          component: resolve =>
            require(["@/page/article/add_news.vue"], resolve)
        },
        {
          path: "/article/video_list",
          name: "/article/video_list",
          component: resolve =>
            require(["@/page/article/video_list.vue"], resolve)
        },
        {
          path: "/article/add_video",
          name: "/article/article_list",
          component: resolve =>
            require(["@/page/article/add_video.vue"], resolve)
        },
        {
          path: "/article/news_video",
          name: "/article/news_video",
          component: resolve =>
            require(["@/page/article/news_video.vue"], resolve)
        },
        {
          path: "/article/add_news_video",
          name: "/article/add_news_video",
          component: resolve =>
            require(["@/page/article/add_news_video.vue"], resolve)
        },
        {
          path: "/tag/case",
          name: "/tag/case",
          component: resolve => require(["@/page/tag/case.vue"], resolve)
        },
        {
          path: "/tag/add_case",
          name: "/tag/case",
          component: resolve => require(["@/page/tag/add_case.vue"], resolve)
        },
        {
          path: "/tag/recruit",
          name: "/tag/recruit",
          component: resolve => require(["@/page/tag/recruit.vue"], resolve)
        },
        {
          path: "/tag/add_recruit",
          name: "/tag/recruit",
          component: resolve => require(["@/page/tag/add_recruit.vue"], resolve)
        },
        {
          path: "/tag/depth",
          name: "/tag/depth",
          component: resolve => require(["@/page/tag/depth.vue"], resolve)
        },
        {
          path: "/tag/add_depth",
          name: "/tag/depth",
          component: resolve => require(["@/page/tag/add_depth.vue"], resolve)
        },
        {
          path: "/address/value",
          name: "/address/value",
          component: resolve => require(["@/page/address/value.vue"], resolve)
        },
        {
          path: "/address/industry",
          name: "/address/industry",
          component: resolve =>
            require(["@/page/address/industry.vue"], resolve)
        },
        {
          path: "/address/add_industry",
          name: "/address/add_industry",
          component: resolve =>
            require(["@/page/address/add_industry.vue"], resolve)
        },

        // 英文站
        {
          path: "/case_en/add_case",
          name: "/case_en/case_list",
          component: resolve =>
            require(["@/page/case_en/add_case.vue"], resolve)
        },
        {
          path: "/case_en/case_list",
          name: "/case_en/case_list",
          component: resolve =>
            require(["@/page/case_en/case_list.vue"], resolve)
        },
        {
          path: "/member_en/add_member",
          name: "/member_en/member_list",
          component: resolve =>
            require(["@/page/member_en/add_member.vue"], resolve)
        },
        {
          path: "/member_en/member_list",
          name: "/member_en/member_list",
          component: resolve =>
            require(["@/page/member_en/member_list.vue"], resolve)
        },
        {
          path: "/address_en/address",
          name: "/address_en/address",
          component: resolve =>
            require(["@/page/address_en/address.vue"], resolve)
        },
        {
          path: "/address_en/add_address",
          name: "/address_en/address",
          component: resolve =>
            require(["@/page/address_en/add_address.vue"], resolve)
        },
        {
          path: "/article_en/article_list",
          name: "/article_en/article_list",
          component: resolve =>
            require(["@/page/article_en/article_list.vue"], resolve)
        },
        {
          path: "/article_en/add_article",
          name: "/article_en/article_list",
          component: resolve =>
            require(["@/page/article_en/add_article.vue"], resolve)
        },

        {
          path: "/article_en/news_list",
          name: "/article_en/news_list",
          component: resolve =>
            require(["@/page/article_en/news_list.vue"], resolve)
        },
        {
          path: "/article_en/add_news",
          name: "/article_en/add_news",
          component: resolve =>
            require(["@/page/article_en/add_news.vue"], resolve)
        },
        {
          path: "/article_en/video_list",
          name: "/article_en/video_list",
          component: resolve =>
            require(["@/page/article_en/video_list.vue"], resolve)
        },
        {
          path: "/article_en/add_video",
          name: "/article_en/article_list",
          component: resolve =>
            require(["@/page/article_en/add_video.vue"], resolve)
        },

        {
          path: "/article_en/news_video",
          name: "/article_en/news_video",
          component: resolve =>
            require(["@/page/article_en/news_video.vue"], resolve)
        },
        {
          path: "/article_en/add_news_video",
          name: "/article_en/add_news_video",
          component: resolve =>
            require(["@/page/article_en/add_news_video.vue"], resolve)
        },

        {
          path: "/tag_en/case",
          name: "/tag_en/case",
          component: resolve => require(["@/page/tag_en/case.vue"], resolve)
        },
        {
          path: "/tag_en/add_case",
          name: "/tag_en/case",
          component: resolve => require(["@/page/tag_en/add_case.vue"], resolve)
        },
        {
          path: "/tag_en/recruit",
          name: "/tag_en/recruit",
          component: resolve => require(["@/page/tag_en/recruit.vue"], resolve)
        },
        {
          path: "/tag_en/add_recruit",
          name: "/tag_en/recruit",
          component: resolve =>
            require(["@/page/tag_en/add_recruit.vue"], resolve)
        },
        {
          path: "/tag_en/depth",
          name: "/tag_en/depth",
          component: resolve => require(["@/page/tag_en/depth.vue"], resolve)
        },
        {
          path: "/tag_en/add_depth",
          name: "/tag_en/depth",
          component: resolve =>
            require(["@/page/tag_en/add_depth.vue"], resolve)
        },
        {
          path: "/address_en/value",
          name: "/address_en/value",
          component: resolve =>
            require(["@/page/address_en/value.vue"], resolve)
        },
        {
          path: "/address_en/industry",
          name: "/address_en/industry",
          component: resolve =>
            require(["@/page/address_en/industry.vue"], resolve)
        },
        {
          path: "/address_en/add_industry",
          name: "/address_en/add_industry",
          component: resolve =>
            require(["@/page/address_en/add_industry.vue"], resolve)
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js